// Spanish for the shell, routes (login, account, users, site/camera pages), portfolio, ui and alerts.
export const SHELL_ROUTES: Record<string, string> = {
  '1 camera': '1 cámara',
  '1 camera offline': '1 cámara sin conexión',
  'AI cost': 'Coste de IA',
  Account: 'Cuenta',
  Acknowledge: 'Marcar como vista',
  Acknowledged: 'Vista',
  'Acknowledging…': 'Marcando…',
  Active: 'Activa',
  Alerts: 'Alertas',
  'All sites': 'Todas las obras',
  'All sites (admin)': 'Todas las obras (admin)',
  'Back to portfolio': 'Volver a las obras',
  'Camera offline': 'Cámara sin conexión',
  'Change password': 'Cambiar contraseña',
  Chat: 'Chat',
  'Chat access': 'Acceso al chat',
  'Chatbot disabled': 'Chat desactivado',
  'Choose a password different from the one you were given.': 'Elige una contraseña distinta de la que te dieron.',
  'Choose your own password': 'Elige tu propia contraseña',
  Close: 'Cerrar',
  'Close drawer backdrop': 'Cerrar el panel',
  Collapse: 'Reducir',
  'Collapse drawer': 'Reducir el panel',
  'Confirm new password': 'Confirma la nueva contraseña',
  'Could not change password': 'No se pudo cambiar la contraseña',
  'Could not change password ({status})': 'No se pudo cambiar la contraseña ({status})',
  'Create one with:': 'Crea una con:',
  Created: 'Creado',
  'Current password': 'Contraseña actual',
  'Current password is incorrect.': 'La contraseña actual no es correcta.',
  'Dark mode': 'Modo oscuro',
  'Display-only panel. To create, edit, delete, reset passwords or change site access, ask the chatbot — it can call the user-management tools for you.':
    'Panel solo de consulta. Para crear, editar o borrar usuarios, restablecer contraseñas o cambiar el acceso a las obras, pídeselo al chat: puede usar las herramientas de gestión de usuarios por ti.',
  Drawer: 'Panel',
  Email: 'Correo electrónico',
  Expand: 'Ampliar',
  'Expand drawer': 'Ampliar el panel',
  'Failed to load users ({status})': 'No se pudieron cargar los usuarios ({status})',
  Flags: 'Indicadores',
  'Last analyzed {when}': 'Último análisis {when}',
  'Last login': 'Último acceso',
  'Light mode': 'Modo claro',
  'Loading AI cost…': 'Cargando el coste de IA…',
  'Loading alerts…': 'Cargando alertas…',
  'Loading camera…': 'Cargando la cámara…',
  'Loading projects…': 'Cargando las obras…',
  'Loading site…': 'Cargando la obra…',
  'Loading view…': 'Cargando la vista…',
  'Loading…': 'Cargando…',
  'Log out': 'Cerrar sesión',
  'Login failed': 'No se pudo iniciar sesión',
  'Must change password on next login': 'Debe cambiar la contraseña en el próximo acceso',
  Name: 'Nombre',
  'New password': 'Nueva contraseña',
  'New password must be at least 8 characters.': 'La nueva contraseña debe tener al menos 8 caracteres.',
  'New passwords do not match.': 'Las nuevas contraseñas no coinciden.',
  'No alerts': 'No hay alertas',
  'No camera configured': 'Sin cámara configurada',
  'No image available': 'No hay imagen disponible',
  'No pending alerts': 'No hay alertas pendientes',
  'No projects configured.': 'No hay obras configuradas.',
  'No tools granted': 'Sin herramientas asignadas',
  'No users.': 'No hay usuarios.',
  'None assigned': 'Ninguna asignada',
  Notes: 'Notas',
  Password: 'Contraseña',
  'Password changed.': 'Contraseña cambiada.',
  'Password rotation not required': 'No hace falta cambiar la contraseña',
  'Password you were given': 'Contraseña que te dieron',
  Paused: 'En pausa',
  'Pending only': 'Solo pendientes',
  'Read tools ({n})': 'Herramientas de lectura ({n})',
  Retry: 'Reintentar',
  Role: 'Rol',
  'Saving…': 'Guardando…',
  'Sign in': 'Entrar',
  'Sign in to continue.': 'Inicia sesión para continuar.',
  'Signing in…': 'Entrando…',
  Sites: 'Obras',
  'Something went wrong.': 'Algo ha fallado.',
  'Switch to dark mode': 'Cambiar a modo oscuro',
  'Switch to light mode': 'Cambiar a modo claro',
  'This composed view is no longer available.': 'Esta vista ya no está disponible.',
  'Upload failed: {detail}': 'No se pudo subir: {detail}',
  Users: 'Usuarios',
  'Welcome to Zonoo. Before you start, replace the password you were given with one only you know.':
    'Bienvenido a Zonoo. Antes de empezar, cambia la contraseña que te dieron por una que solo conozcas tú.',
  'Write tools ({n})': 'Herramientas de escritura ({n})',
  'Your projects': 'Tus obras',
  never: 'nunca',
  no: 'no',
  'since {when}': 'desde {when}',
  'yes · {n} tools': 'sí · {n} herramientas',
  '{name} snapshot': 'Imagen de {name}',
  '{n} cameras': '{n} cámaras',
  '{n} cameras offline': '{n} cámaras sin conexión',
  "You don't have access to the user manager.": 'No tienes acceso a la gestión de usuarios.',
}
